import {
  TRANSFER_STATUS_TO_LABEL,
  TRANSFER_TYPE_TO_SHORT_LABEL,
  TransferProductCostCompleted,
  type TransferStatusFilterValue,
  TransferSyncStatusFilter,
} from "../constants"

import { TransferStatus, type TransferType, UserCreatedRecordType } from "@/graphql/codegen/graphql"
import { useGetUserOptions } from "@/hooks/useGetUserOptions"
import { useGetWarehouseOptions } from "@/hooks/useGetWarehouseOptions"
import type { Option } from "@/types/form-fields"

const TYPE_OPTIONS: Option<TransferType>[] = Object.entries(TRANSFER_TYPE_TO_SHORT_LABEL).map(([value, label]) => ({
  value: value as TransferType,
  label,
}))

const STATUS_OPTIONS: Option<TransferStatusFilterValue>[] = [
  { value: TransferStatus.Draft, label: TRANSFER_STATUS_TO_LABEL[TransferStatus.Draft] },
  { value: TransferSyncStatusFilter.PendingSync, label: "Pending Sync to AS400" },
  { value: TransferSyncStatusFilter.PartiallyFailed, label: "Partially Failed" },
  { value: TransferSyncStatusFilter.FailedCreation, label: "Failed Creation" },
  { value: TransferStatus.PendingPick, label: TRANSFER_STATUS_TO_LABEL[TransferStatus.PendingPick] },
  {
    value: TransferStatus.PendingPickAndPutaway,
    label: TRANSFER_STATUS_TO_LABEL[TransferStatus.PendingPickAndPutaway],
  },
  { value: TransferStatus.PendingShip, label: TRANSFER_STATUS_TO_LABEL[TransferStatus.PendingShip] },
  { value: TransferStatus.InTransit, label: TRANSFER_STATUS_TO_LABEL[TransferStatus.InTransit] },
  { value: TransferStatus.Received, label: TRANSFER_STATUS_TO_LABEL[TransferStatus.Received] },
  { value: TransferStatus.Completed, label: TRANSFER_STATUS_TO_LABEL[TransferStatus.Completed] },
]

const PRODUCT_COST_COMPLETED_OPTIONS: Option<TransferProductCostCompleted>[] = [
  { value: TransferProductCostCompleted.All, label: "All" },
  { value: TransferProductCostCompleted.No, label: "No" },
  { value: TransferProductCostCompleted.Yes, label: "Yes" },
]

interface UseTransferFilterOptionsReturn {
  typeOptions: Option<TransferType>[]
  statusOptions: Option<TransferStatusFilterValue>[]
  productCostCompletedOptions: Option<TransferProductCostCompleted>[]
  warehouseOptions: Option<string>[]
  isWarehouseOptionsFetching: boolean
  createdByOptions: Option<string>[]
  isCreatedByOptionsFetching: boolean
}

export const useTransferFilterOptions = (): UseTransferFilterOptionsReturn => {
  const { warehouseOptions, isFetching: isWarehouseOptionsFetching } = useGetWarehouseOptions({
    isInventoryRelated: true,
  })
  const { userOptions: createdByOptions, isFetching: isCreatedByOptionsFetching } = useGetUserOptions({
    createdRecordTypes: [UserCreatedRecordType.Transfer],
  })

  return {
    typeOptions: TYPE_OPTIONS,
    statusOptions: STATUS_OPTIONS,
    productCostCompletedOptions: PRODUCT_COST_COMPLETED_OPTIONS,
    warehouseOptions,
    isWarehouseOptionsFetching,
    createdByOptions,
    isCreatedByOptionsFetching,
  }
}
